module.exports = __webpack_public_path__ + "static/img/qrcode.0d3fa5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.png
// module id = 62
// module chunks = 0